import { Box, Button, Typography } from "@mui/material";
import { ShieldIcon } from "../Core/Icons/Shield";
import axios from "axios";
import { useState } from "react";
import Form from "./components/Form";
import ThirdPartyContacts from "./components/ThirdPartyContacts";
import { base64toBlob } from "@/utils/Base64ToBlob";
import api from "@/api/api";
import ActiveTaskModal from "./components/ActiveTaskModal";
import Reject from "../Reject/Reject";
import { useReject } from "@/hooks/useReject";
import { useDispatch, useSelector } from "react-redux";
import {
  openBiometry,
  visibleBiometry,
} from "@/store/slices/biometryModalSlice";
import { ThirdPartyContact, ContactsData } from "@/constans/contactRoles";
import { validateKazakhPhone } from "@/utils/phoneValidation";
import { validateCyrillic } from "@/utils/cyrillicValidation";

const Borrower = ({
  sendUserData,
  continueTask,
  hasCredentials = false,
  btnClicked,
  setBiometryModal,
}) => {
  const [openReject, setOpenReject] = useState(false);
  const { setRejectOpen, setInfoKey } = useReject();
  const { clientInfo } = useSelector((state: any) => state.user);
  const getAgreement = async (payload) => {
    try {
      const { data } = await axios.get(
        `${process.env.NEXT_PUBLIC_BASE_URL}/colvir/agreement/${payload}`
      );
      return data;
    } catch (e) {
      setInfoKey("7");
      setRejectOpen(true);
      throw e;
    }
  };

  const generateAgreement = async () => {
    const isFullIIN = iin.length === 12;

    if (!isFullIIN) {
      setIInErr(true);
      return;
    } else {
      setIInErr(false);
    }

    getAgreement(iin).then((result) => {
      const base64 = result.data;
      const blob = base64toBlob(base64, "application/pdf");
      window.open(URL.createObjectURL(blob), "_blank")?.focus();
    });
  };

  const [phone, setPhone] = useState(hasCredentials ? clientInfo?.phone : "");
  const [email, setEmail] = useState(hasCredentials ? clientInfo?.email : "");
  const [iin, setIin] = useState(hasCredentials ? clientInfo?.iin : "");

  const [error, setError] = useState(false);
  const [iinErr, setIInErr] = useState(false);
  const [phoneErr, setPhoneErr] = useState(false);
  const [dateErr, setDateErr] = useState(false);
  const [branchErr, setBranchErr] = useState(false);

  // Состояние для контактов третьих лиц
  const [thirdPartyContacts, setThirdPartyContacts] = useState<ThirdPartyContact[]>([
    { fio: '', mobile: '', role: { code: '', value: '' } },
    { fio: '', mobile: '', role: { code: '', value: '' } },
  ]);
  
  // Ошибки валидации для контактов третьих лиц
  const [contactsErrors, setContactsErrors] = useState({
    contact1: { fio: '', mobile: '', role: '' },
    contact2: { fio: '', mobile: '', role: '' },
  });

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const [branch, setBranch] = useState(
    hasCredentials ? clientInfo?.branch : ""
  );
  const [startDate, setStartDate] = useState(null);
  const [openActivetask, setOpenActiveTask] = useState(false);
  const [activeTask, setactiveTask] = useState<any>([]);

  const getActiveTask = async (payload) => {
    try {
      const { data } = await axios.get(
        `${process.env.NEXT_PUBLIC_BASE_URL}/application/clients?iin=${payload}`,
        {
          headers: {
            "X-User-ID": `+7${phone}`,
          },
        }
      );

      if (data) {
        localStorage.setItem("token", data[0]?.token);
      }

      return data;
    } catch (e: any) {
      if (e.response.status === 404) {
        return [];
      }
      setInfoKey("7");
      setRejectOpen(true);
      throw e;
    }
  };

  // const getIINInfo = async () => {
  //   const response = await fetch(
  //     `https://bccgov.vercel.app/api/getInfo/${iin}`
  //   );
  //   if (response.status === 500) {
  //     setOpenReject(true);
  //     throw response;
  //   }
  //   return response.json();
  // };

  const validateForm = async () => {
    const isFullIIN = iin.length === 12;
    const phoneValidation = validateKazakhPhone(phone);

    // Валидация основных полей
    if (!isFullIIN) {
      setIInErr(true);
    }
    if (!phoneValidation.isValid) {
      setPhoneErr(true);
    }
    if (!isValidEmail(email)) {
      setError(true);
    }
    // if (!startDate) {
    //   setDateErr(true);
    // }
    if (!branch) {
      setBranchErr(true);
    }

    // Валидация контактов третьих лиц
    const newContactsErrors = {
      contact1: { fio: '', mobile: '', role: '' },
      contact2: { fio: '', mobile: '', role: '' },
    };

    let hasContactErrors = false;

    // Собираем все номера телефонов для проверки дублирования
    const phoneNumbers = thirdPartyContacts.map(contact => contact.mobile.trim()).filter(phone => phone);
    
    thirdPartyContacts.forEach((contact, index) => {
      const contactKey = index === 0 ? 'contact1' : 'contact2';
      
      // Контакты третьих лиц ОБЯЗАТЕЛЬНЫ для заполнения
      // Валидация ФИО
      if (!contact.fio.trim()) {
        newContactsErrors[contactKey].fio = 'Поле ФИО обязательно для заполнения';
        hasContactErrors = true;
      } else {
        // Проверяем кириллицу
        const cyrillicValidation = validateCyrillic(contact.fio);
        if (!cyrillicValidation.isValid) {
          newContactsErrors[contactKey].fio = cyrillicValidation.error || 'Некорректное ФИО';
          hasContactErrors = true;
        }
      }
      
      // Валидация мобильного номера
      if (!contact.mobile.trim()) {
        newContactsErrors[contactKey].mobile = 'Поле мобильный номер обязательно для заполнения';
        hasContactErrors = true;
      } else {
        // Валидируем номер телефона контакта
        const contactPhoneValidation = validateKazakhPhone(contact.mobile);
        if (!contactPhoneValidation.isValid) {
          newContactsErrors[contactKey].mobile = contactPhoneValidation.error || 'Некорректный номер телефона';
          hasContactErrors = true;
        } else {
          // Проверяем дублирование номеров
          const currentPhone = contact.mobile.trim();
          const duplicateIndex = phoneNumbers.findIndex((phone, idx) => 
            phone === currentPhone && idx !== index
          );
          
          if (duplicateIndex !== -1) {
            const duplicateContactNumber = duplicateIndex + 1;
            const currentContactNumber = index + 1;
            
            // Показываем ошибку только для второго дублированного номера
            if (index > duplicateIndex) {
              newContactsErrors[contactKey].mobile = `Этот номер телефона уже указан для ${duplicateContactNumber === 1 ? 'первого' : 'второго'} контакта`;
              hasContactErrors = true;
            }
          }
        }
      }
      
      // Валидация роли
      if (!contact.role.code) {
        newContactsErrors[contactKey].role = 'Выберите роль контакта';
        hasContactErrors = true;
      } else if (contact.role.code === 'other') {
        // Если выбрано "другое", проверяем значение в role.value
        if (!contact.role.value || !contact.role.value.trim()) {
          newContactsErrors[contactKey].role = 'Укажите роль контакта';
          hasContactErrors = true;
        } else if (contact.role.value.trim().length < 2) {
          newContactsErrors[contactKey].role = 'Роль должна содержать минимум 2 символа';
          hasContactErrors = true;
        } else if (contact.role.value.trim().length > 50) {
          newContactsErrors[contactKey].role = 'Роль не должна превышать 50 символов';
          hasContactErrors = true;
        }
      }
    });

    setContactsErrors(newContactsErrors);

    if (
      !isFullIIN ||
      !phoneValidation.isValid ||
      !isValidEmail(email) ||
      // !startDate ||
      !branch ||
      hasContactErrors
    ) {
      return;
    }
    // const data = await getIINInfo();
    const activeTask = await getActiveTask(iin);
    if (activeTask.length) {
      setactiveTask(activeTask);
      setOpenActiveTask(true);
      return;
    }
    const date = new Date().toLocaleDateString().split(".").reverse().join("-");

    // const dateString = data?.dateRegistration.substring(0, 10);
    // const [day, month, year] = dateString.split(".");
    // const formattedDate = `${year}-${month}-${day}`;

    // Формируем структуру данных для контактов
    // Теперь контакты обязательны, поэтому отправляем все валидные контакты
    const contactsData: ContactsData = {
      contacts: thirdPartyContacts
        .filter(contact => {
          const hasBasicData = contact.fio.trim() && contact.mobile.trim() && contact.role.code;
          const hasValidRole = contact.role.code !== 'other' || (contact.role.value && contact.role.value.trim());
          return hasBasicData && hasValidRole;
        })
        .map(contact => ({
          ...contact,
          mobile: `+7${contact.mobile}` // Добавляем префикс +7 к номеру телефона
        }))
    };

    await sendUserData({
      iin,
      phone,
      email,
      date: date,
      branch,
      activeTask: activeTask[activeTask.length - 1],
      contacts: contactsData.contacts,
    });
  };

  const handleAction = async () => {
    setOpenActiveTask(false);
    const date = new Date().toLocaleDateString().split(".").reverse().join("-");

    // Формируем структуру данных для контактов
    // Теперь контакты обязательны, поэтому отправляем все валидные контакты
    const contactsData: ContactsData = {
      contacts: thirdPartyContacts
        .filter(contact => {
          const hasBasicData = contact.fio.trim() && contact.mobile.trim() && contact.role.code;
          const hasValidRole = contact.role.code !== 'other' || (contact.role.value && contact.role.value.trim());
          return hasBasicData && hasValidRole;
        })
        .map(contact => ({
          ...contact,
          mobile: `+7${contact.mobile}` // Добавляем префикс +7 к номеру телефона
        }))
    };

    await sendUserData({
      iin,
      phone,
      email,
      date,
      branch,
      activeTask: activeTask[activeTask.length - 1],
      contacts: contactsData.contacts,
    });
  };

  const dispatch = useDispatch();

  const handleContinue = async () => {
    const date = new Date().toLocaleDateString().split(".").reverse().join("-");

    if (activeTask[0]?.eventName === "BIOMETRIC") {
      setBiometryModal(true);
      setOpenActiveTask(false);
      return;
    }

    // Формируем структуру данных для контактов
    // Теперь контакты обязательны, поэтому отправляем все валидные контакты
    const contactsData: ContactsData = {
      contacts: thirdPartyContacts
        .filter(contact => {
          const hasBasicData = contact.fio.trim() && contact.mobile.trim() && contact.role.code;
          const hasValidRole = contact.role.code !== 'other' || (contact.role.value && contact.role.value.trim());
          return hasBasicData && hasValidRole;
        })
        .map(contact => ({
          ...contact,
          mobile: `+7${contact.mobile}` // Добавляем префикс +7 к номеру телефона
        }))
    };

    await continueTask({
      iin,
      phone,
      email,
      date,
      branch,
      activeTask: activeTask[activeTask.length - 1],
      contacts: contactsData.contacts,
    });
    setOpenActiveTask(false);
  };

  return (
    <Box>
      <Typography
        component="p"
        variant="h4"
        textAlign="center"
        marginBottom="40px"
        sx={(theme) => ({
          fontSize: "40px",
          fontWeight: "700",
          lineHeight: "130%",
          [theme.breakpoints.down("sm")]: {
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "32px",
            marginBottom: "24px",
          },
        })}
      >
        Данные заёмщика
      </Typography>
      <Box
        sx={(theme) => ({
          maxWidth: "968px",
          margin: "0 auto",
          backgroundColor: "#FFF",
          padding: "48px",
          borderRadius: "24px",
          [theme.breakpoints.down("sm")]: {
            padding: "24px 16px",
            margin: "0 16px",
          },
        })}
      >
        <Form
          iin={iin}
          setBranch={setBranch}
          setEmail={setEmail}
          setError={setError}
          setIin={setIin}
          setPhone={setPhone}
          setStartDate={setStartDate}
          startDate={startDate}
          email={email}
          error={error}
          branch={branch}
          branchErr={branchErr}
          phone={phone}
          phoneErr={phoneErr}
          iinErr={iinErr}
          isValidEmail={isValidEmail}
          dateErr={dateErr}
          setIInErr={setIInErr}
          setPhoneErr={setPhoneErr}
          setBranchErr={setBranchErr}
          setDateErr={setDateErr}
        />
        
        <ThirdPartyContacts
          businessType="IP"
          contacts={thirdPartyContacts}
          onContactsChange={setThirdPartyContacts}
          errors={contactsErrors}
        />
        <Box
          sx={{
            display: "flex",
            padding: "12px 16px",
            marginTop: "24px",
            backgroundColor: "#F3F3F7",
            borderRadius: "8px",
          }}
        >
          <ShieldIcon />
          <Typography
            sx={(theme) => ({
              marginLeft: "16px",
              color: "#676971",
              [theme.breakpoints.down("sm")]: {
                fontSize: "14px",
                lineHeight: "19px",
              },
            })}
          >
            Ваши данные под надежной защитой
          </Typography>
        </Box>
        <Box
          sx={(theme) => ({
            display: "flex",
            justifyContent: "flex-end",
            paddingTop: "16px",
            marginTop: "16px",
            borderTop: "1px solid #D1D5E5",
            [theme.breakpoints.down("sm")]: {
              flexDirection: "column",
            },
          })}
        >
          <Button
            onClick={validateForm}
            disabled={btnClicked}
            sx={(theme) => ({
              minWidth: "260px",
              marginLeft: "16px",
              maxHeight: "48px",
              borderRadius: "10px",
              backgroundColor: "#27AE60",
              color: "#FFF",
              fontSize: "16px",
              fontWeight: "500",
              ":hover": {
                background: "#27AE60",
                color: "#FFF",
              },
              [theme.breakpoints.down("sm")]: {
                margin: "16px 0 0",
              },
            })}
          >
            Получить решение
          </Button>
        </Box>
      </Box>
      {openActivetask && (
        <ActiveTaskModal
          open={openActivetask}
          handleContinue={handleContinue}
          handleAction={handleAction}
        />
      )}
      {openReject && (
        <Reject open={openReject} setOpen={setOpenReject} infoKey="11" />
      )}
    </Box>
  );
};

export default Borrower;
